import { gql } from "@apollo/client";

export const getSurveyDetails = gql`
query GetSurveyDetails($_or: [survey_responses_bool_exp!] = {}, $id: bigint = "1614") {
  survey_responses(where: {survey_id: {_eq: $id}, _or: $_or}) {
    response_details
    id
    survey_id
    user {
      name
      phone_number
    }
  }
}
`